'use client';

import { useEffect } from 'react';
import posthog from 'posthog-js';
import { _POSTHOG_SHARED_CONFIG } from './shared';

declare global {
    interface Window {
        /** The PostHog toolbar looks the client up here when it is launched from
         * the PostHog UI. Importing `posthog-js` as a module never puts it on
         * `window`, so the init assigns it in its `loaded` callback. */
        posthog?: typeof posthog;
        __FUNKEY_POSTHOG_DEBUG__?: {
            enabled: boolean;
            initialized: boolean;
            host: string;
            uiHost: string;
            environment: string;
            distinctId?: string;
        };
    }
}

export function updatePostHogDebugState(): void {
    if (typeof window === 'undefined') return;

    window.__FUNKEY_POSTHOG_DEBUG__ = {
        enabled: _POSTHOG_SHARED_CONFIG.ENABLED,
        initialized: posthog.__loaded === true,
        host: _POSTHOG_SHARED_CONFIG.HOST,
        uiHost: _POSTHOG_SHARED_CONFIG.UI_HOST,
        environment: _POSTHOG_SHARED_CONFIG.ENVIRONMENT,
        distinctId: posthog.__loaded === true ? posthog.get_distinct_id() : undefined,
    };
}

export const PostHogDebugState: React.FC = () => {
    useEffect(() => {
        updatePostHogDebugState();

        // Launching the toolbar puts its parameters in the URL fragment. If
        // analytics are switched off for this deployment nothing ever reads
        // them, and the toolbar simply never appears with no explanation —
        // which looks identical to it being broken.
        if (!_POSTHOG_SHARED_CONFIG.ENABLED && window.location.hash.includes('__posthog')) {
            console.warn(
                'PostHog toolbar cannot start: analytics are disabled for this deployment. ' +
                    'Set NEXT_PUBLIC_POSTHOG_ENABLED=true for this environment and redeploy.',
            );
        }
    }, []);

    return null;
};
